import { useQuery } from '@tanstack/react-query'
import requests from 'service/api'

import SearchSelect from '../search-select'
import { useEffect, useState } from 'react'
import { useFormikContext } from 'formik'

export function SelectReferanceCode2({ name, brannd }) {
  const { values } = useFormikContext()
  const [selected, setSelected] = useState(null)

  const { data, isFetched } = useQuery({
    queryKey: ['/list', 'referance'],
    queryFn: async () => {
      const { data } = await requests.referance.list()
      return data
    },
    placeholderData: []
  })

  // 🔑 labelCategory ZaraHome için farklı seçiliyor
  const labelCategory = brannd === 'ZaraHome' ? 'TRIMAN ETİKETİ' : 'UYARI ETİKETİ'

  const filtered = (data || []).filter((item) => item.labelCategory === labelCategory)

  const options = filtered.map(({ id, code }) => ({
    value: id,
    label: code,
  }))

  useEffect(() => {
    if (values?.warningLabel?.[0]?.referanceCode && isFetched) {
      const select = options.find(({ value }) => value === values.warningLabel[0].referanceCode)
      setSelected(select || null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values?.warningLabel?.[0]?.referanceCode, isFetched])

  return (
    <SearchSelect
      name={name}
      label="Referans Kodu"
      options={options}
      value={selected}
      onChange={(e) => setSelected(e)}
    />
  )
}
